import React, { Component } from 'react'
import './Chat.scss';

export class Chat extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default Chat

